export default __webpack_public_path__ + "static/media/ngayogyan-indo.9dcdfa1c.ttf";